import { createContext, useContext } from "react";
import { ToastProviderHookProps } from "./ToastProvider.types.js";

export const ToastContext = createContext<ToastProviderHookProps>({} as ToastProviderHookProps);

export const useToastContext = () => useContext(ToastContext);
